<template>
    <div id="home-transparency">
        <div class="natrix-illustration-wrapper">
            <div class="illustration-container">
                <div class="natrix-web-illustration" />
            </div>
        </div>
        <div class="content-container">
            <div class="content-inner">
                <div class="container">
                    <div class="content-section">
                        <div class="title headline-l" v-html="$t('homeScreen.transparency.title')"></div>
                        <div class="natrix-illustration-mobile-wrapper">
                            <div class="natrix-mobile-illustration" />
                        </div>
                        <div class="bottom-section">
                            <div class="subscription" v-html="$t('homeScreen.transparency.description')">
                            </div>
                            <base-button class="join-button" :text="$t('homeScreen.transparency.buttonText')"
                                size="large" type="light-green" @clicked="handleClick" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'HomeTransparency',
    props: {
        customTransform: {
            type: String,
            default: '',
        },
    },
    components: {},
    data: () => ({}),
    created() { },
    computed: {},
    methods: {
        handleClick() {
            this.$emit('buttonClicked');
        },
    },
};
</script>

<style lang="scss" scoped>
#home-transparency {
    height: 564px;
    width: 100%;
    background: #040428;

    @media (max-width: $breakpoint-md) {
        height: fit-content;
    }

    .natrix-illustration-mobile-wrapper {
        justify-content: center;
        display: flex;
        margin-bottom: $margin-s;
        height: 327px;
        width: 100%;

        @media (min-width: $breakpoint-md) {
            display: none;
        }

        .natrix-mobile-illustration {
            height: 327px;
            width: 100%;
            position: absolute;
            object-fit: cover;
            background: url('/images/elements/home/web/transparency-illustration.png') no-repeat center center;
            background-size: cover;
            background-position: center;

            &::before {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 327px;
                background-color: #4656FF;
                mix-blend-mode: color;
                z-index: 1;
                pointer-events: none;
            }
        }
    }

    .natrix-illustration-wrapper {
        height: 564px;
        width: 100%;
        position: absolute;
        align-items: center;
        display: flex;

        @media (max-width: $breakpoint-md) {
            display: none;
        }

        .natrix-web-illustration {
            position: absolute;
            z-index: 1;
            right: 0;
            height: 564px;
            width: 608px;
            object-fit: cover;
            background: url('/images/elements/home/web/transparency-illustration.png') no-repeat center center;
            background-size: cover;
            background-position: center;

            &::before {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-color: #4656FF;
                mix-blend-mode: color;
                z-index: 1;
                pointer-events: none;
            }

            @media (max-width: $breakpoint-lg) {
                width: 500px;
            }

            @media (max-width: $breakpoint-xs) {
                position: relative;
            }
        }
    }

    .illustration-container {
        height: 564px;
        display: flex;
        align-items: center;
        position: relative;
        width: 100%;
    }

    .container {
        @media (min-width: $breakpoint-lg) {
            max-width: 1196px;
        }

        @media (max-width: $breakpoint-xs) {
            padding-left: 0px;
            padding-right: 0px;
        }
    }

    .content-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 100%;

        .content-inner {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            z-index: 1;

            .content-section {
                .title {
                    max-width: 630px;
                    margin-bottom: 40px;
                    letter-spacing: 0em;
                    text-align: left;
                    text-transform: uppercase;
                    color: $white;

                    @media (max-width: $breakpoint-lg) {
                        max-width: 460px;
                    }

                    @media (max-width: $breakpoint-md) {
                        text-align: center;
                        max-width: unset;
                    }
                }

                .bottom-section {
                    @media (max-width: $breakpoint-xs) {
                        padding-left: 15px;
                        padding-right: 15px;
                    }
                }

                .subscription {
                    max-width: 630px;
                    margin-bottom: 40px;
                    font-size: 16px;
                    font-weight: 400;
                    line-height: 30px;
                    letter-spacing: 0em;
                    text-align: left;
                    color: $white;

                    @media (max-width: $breakpoint-lg) {
                        max-width: 460px;
                    }

                    @media (max-width: $breakpoint-md) {
                        text-align: center;
                        max-width: unset;
                    }
                }

                .join-button {
                    text-transform: uppercase;

                    @media (max-width: $breakpoint-md) {
                        width: 100%;
                    }
                }
            }
        }
    }
}

@media (max-width: $breakpoint-md) {
    #home-transparency {
        .content-container {
            padding-top: $margin-m;
            padding-bottom: 80px;
        }
    }
}
</style>
